export enum TimePeriodTypeEnum {
    YearDescription = 'Year',
    YRS = 1,
    QuarterDescription = 'Quarter',
    QRT = 2,
    MonthDescription = 'Month',
    MTH = 3
}